var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { id: "dictamen-general", fluid: "" } },
    [
      !this.revision.respuesta.evaluacionGuardadaFinal
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _vm._v(
              "\n    Deberá finalizar el apartado evaluación invidual para continuar con el proceso.\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.solicitud && _vm.revision
        ? _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.guardarDictamen.apply(null, arguments)
                },
              },
            },
            [
              this.revision.respuesta.evaluacionGuardadaFinal
                ? _c(
                    "b-container",
                    {
                      staticClass: "border text-justify dictamen-evaluacion",
                      attrs: { id: "dictamen-2026" },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "b-col",
                            [
                              _vm.esExcepcionPerfilDictamen
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(
                                        "\n              del Área\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ", recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.nombreNivelExcepcionDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis realizado de manera conjunta y sus respectivas equivalencias de la información registrada\n              en el Perfil Único y las consideraciones presentadas en su solicitud, de conformidad con lo establecido en el marco de la\n              Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores, se determina que, con\n              fundamento en el artículo 12 de los Criterios Específicos de Evaluación del Sistema Nacional de Investigadoras e\n              Investigadores, la Comisión considera que la trayectoria de investigación es notable por:\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.esExcepcionPerfilDictamen
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentarioExcepcion"
                                                  )
                                                ),
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenNegativo
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenNegativo,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenNegativo.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Faltan " +
                                                            _vm._s(
                                                              _vm.caracteresFaltantesDictamenNegativo
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo >
                                                    _vm.caracteresMaximos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El comentario no debe exceder " +
                                                            _vm._s(
                                                              _vm.caracteresMaximos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.esResultadoNegativoPerfilInvestigacionCienciaBasica
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(" del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen) + ","),
                                      ]),
                                      _vm._v(
                                        " recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              otorgar la categoría o nivel "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Lo anterior, con base en los siguientes motivos:"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cuantitativa con lo establecido en el "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 1. “Parámetros del SNII”"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              respecto al componente 1. Producción de investigación científica y humanística, ya que presentó\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalPerfilFronteraCientifica
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos. Respecto al componente 2. Fortalecimiento y Consolidación de\n              la Comunidad, ya que presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteFormacionComunidadDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " actividades. Respecto al\n              componente 3. Divulgación ya que presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteDivulgacionDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              actividades.\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 4. “Rúbrica de Evaluación”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.resultadoCualitativoDictamen
                                          ) + "."
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              Sin embargo, tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria del solicitante a partir\n              del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su solicitud de\n              conformidad con lo establecido en el marco de la Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de\n              Investigadoras e Investigadores, se determina que cumple con los Criterios Específicos de Evaluación correspondientes al\n              nivel "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(" de acuerdo al área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción\n              " +
                                          _vm._s(
                                            _vm.fraccionArticulo19NivelAspiraDictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19NivelAspiraDictamen
                                          ) +
                                          ", del Reglamento del Sistema\n              Nacional de Investigadoras e Investigadores y los Criterios Específicos de Evaluación para la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nombreNivelAspiraDictamen)
                                        ),
                                      ]),
                                      _vm._v(" por:\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _vm.esResultadoNegativoPerfilInvestigacionCienciaBasica
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenNegativo
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenNegativo,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenNegativo.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Faltan " +
                                                            _vm._s(
                                                              _vm.caracteresFaltantesDictamenNegativo
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo >
                                                    _vm.caracteresMaximos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El comentario no debe exceder " +
                                                            _vm._s(
                                                              _vm.caracteresMaximos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.esResultadoNegativoPerfilDesarrolloTecnologicoInnovacion
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(" del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen) + ","),
                                      ]),
                                      _vm._v(
                                        " recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              otorgar la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen) +
                                            "."
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Lo anterior, con base en los siguientes motivos:"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 2. “Parámetros de Tecnología del SNII”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " respecto al componente 1. Producción Tecnológica, ya que\n              presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteProduccionTecno
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos de Desarrollo Tecnológico;\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponentePropiedadIntelectual
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos de Propiedad Intelectual; y,\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteTransferenciaTecno
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos de Transferencia de Tecnología. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteFormacionComunidadDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " actividades. Respecto al componente 3. Divulgación ya que\n              presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteDivulgacionDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              actividades.\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 4. “Rúbrica de Evaluación”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.resultadoCualitativoDictamen
                                            ) +
                                            "."
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              Sin embargo, tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria del solicitante a partir\n              del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su solicitud de\n              conformidad con lo establecido en el marco de la Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de\n              Investigadoras e Investigadores, se determina que cumple con los Criterios Específicos de Evaluación correspondientes al\n              nivel "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(" de acuerdo al área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen) + "."),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción " +
                                          _vm._s(
                                            _vm.fraccionArticulo19NivelAspiraDictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19NivelAspiraDictamen
                                          ) +
                                          ", del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores y los Criterios Específicos de Evaluación para la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nombreNivelAspiraDictamen)
                                        ),
                                      ]),
                                      _vm._v(" por:\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _vm.esResultadoNegativoPerfilDesarrolloTecnologicoInnovacion
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenNegativo
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenNegativo,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenNegativo.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Faltan " +
                                                            _vm._s(
                                                              _vm.caracteresFaltantesDictamenNegativo
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo >
                                                    _vm.caracteresMaximos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El comentario no debe exceder " +
                                                            _vm._s(
                                                              _vm.caracteresMaximos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.esResultadoNegativoPerfilMixto
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(" del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen) + ","),
                                      ]),
                                      _vm._v(
                                        " recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              otorgar la categoría o nivel "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Lo anterior, con base en los siguientes motivos:"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 1. “Parámetros del SNII”"
                                        ),
                                      ]),
                                      _vm._v(" y en el\n              "),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 2. “Parámetros de Tecnología del SNII” "
                                        ),
                                      ]),
                                      _vm._v(
                                        " considerados de manera conjunta y sus respectivas\n              equivalencias conforme al artículo 7 de los Criterios Específicos de Evaluación, respecto al componente 1. Producción de\n              investigación científica, humanística y tecnológica, ya que presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalPerfilMixtoCientificaTecno
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              productos. Respecto al componente 2. Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteFormacionComunidadDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " actividades. Respecto al componente 3. Divulgación ya que\n              presentó\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteDivulgacionDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              actividades.\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 4. “Rúbrica de Evaluación”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.resultadoCualitativoDictamen
                                          ) + "."
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              Sin embargo, tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria del solicitante a partir\n              del análisis realizado de manera conjunta y sus respectivas equivalencias, de la información registrada en el Perfil Único y\n              las consideraciones presentadas en su solicitud de conformidad con lo establecido en el marco de la Convocatoria 2026 para\n              el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores, se determina que cumple con los Criterios\n              Específicos de Evaluación correspondientes al nivel "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(
                                        " de acuerdo al área\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción " +
                                          _vm._s(
                                            _vm.fraccionArticulo19NivelAspiraDictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19NivelAspiraDictamen
                                          ) +
                                          ", del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores y los Criterios Específicos de Evaluación para la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nombreNivelAspiraDictamen)
                                        ),
                                      ]),
                                      _vm._v(" por:\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _vm.esResultadoNegativoPerfilMixto
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenNegativo
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenNegativo,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenNegativo.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Faltan " +
                                                            _vm._s(
                                                              _vm.caracteresFaltantesDictamenNegativo
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo >
                                                    _vm.caracteresMaximos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El comentario no debe exceder " +
                                                            _vm._s(
                                                              _vm.caracteresMaximos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.esNoAprobadoPerfilInvestigacionCienciaBasica
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v("\n              del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ", recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v("no aprobar la solicitud"),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Lo anterior, con base en los siguientes motivos:"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 1. “Parámetros del SNII”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " respecto al componente 1. Producción de investigación científica y\n              humanística, ya que presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalPerfilFronteraCientifica
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteFormacionComunidadDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " actividades. Respecto al componente 3. Divulgación ya que\n              presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteDivulgacionDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              actividades.\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 4. “Rúbrica de Evaluación”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.resultadoCualitativoDictamen
                                          ) + "."
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción\n              " +
                                          _vm._s(
                                            _vm.fraccionArticulo19NivelAspiraDictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19NivelAspiraDictamen
                                          ) +
                                          ", del Reglamento del Sistema\n              Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría o nivel\n              en el SNII por:\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.esNoAprobadoPerfilInvestigacionCienciaBasica
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenNegativo
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenNegativo,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenNegativo.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Faltan " +
                                                            _vm._s(
                                                              _vm.caracteresFaltantesDictamenNegativo
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo >
                                                    _vm.caracteresMaximos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El comentario no debe exceder " +
                                                            _vm._s(
                                                              _vm.caracteresMaximos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.esNoAprobadoPerfilDesarrolloTecnologicoInnovacion
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(" del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ", recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v("no aprobar la solicitud"),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Lo anterior, con base en los siguientes motivos:"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 2. “Parámetros de Tecnología del SNII”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " respecto al componente 1. Producción Tecnológica, ya que\n              presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteProduccionTecno
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos de Desarrollo Tecnológico;\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponentePropiedadIntelectual
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos de Propiedad Intelectual; y,\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteTransferenciaTecno
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos de Transferencia de Tecnología. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteFormacionComunidadDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              actividades. Respecto al componente 3. Divulgación ya que presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteDivulgacionDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              actividades.\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 4. “Rúbrica de Evaluación” "
                                        ),
                                      ]),
                                      _vm._v(
                                        " se consideraron las características para cada uno de los componentes de\n              la trayectoria de investigación, resultando "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.resultadoCualitativoDictamen
                                          ) + "."
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción\n              " +
                                          _vm._s(
                                            _vm.fraccionArticulo19NivelAspiraDictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19NivelAspiraDictamen
                                          ) +
                                          ", del Reglamento del Sistema\n              Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría o nivel\n              en el SNII por:\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.esNoAprobadoPerfilDesarrolloTecnologicoInnovacion
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenNegativo
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenNegativo,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenNegativo.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Faltan " +
                                                            _vm._s(
                                                              _vm.caracteresFaltantesDictamenNegativo
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo >
                                                    _vm.caracteresMaximos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El comentario no debe exceder " +
                                                            _vm._s(
                                                              _vm.caracteresMaximos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.esNoAprobadoPerfilMixto
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(" del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen) + ","),
                                      ]),
                                      _vm._v(
                                        " recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v("no aprobar la solicitud"),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Lo anterior, con base en los siguientes motivos:"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 1. “Parámetros del SNII”"
                                        ),
                                      ]),
                                      _vm._v(" y en el\n              "),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 2. “Parámetros de Tecnología del SNII”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " considerados de manera conjunta y sus respectivas\n              equivalencias conforme al artículo 7, dado que respecto al componente 1. Producción de investigación científica, humanística\n              y tecnológica, ya que presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalPerfilMixtoCientificaTecno
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " productos. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteFormacionComunidadDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " actividades. Respecto al componente 3. Divulgación ya que\n              presentó "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalComponenteDivulgacionDictamen
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              actividades.\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "Anexo 4. “Rúbrica de Evaluación”"
                                        ),
                                      ]),
                                      _vm._v(
                                        " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.resultadoCualitativoDictamen
                                          ) + "."
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción " +
                                          _vm._s(
                                            _vm.fraccionArticulo19NivelAspiraDictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19NivelAspiraDictamen
                                          ) +
                                          ", del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría\n              o nivel en el SNII por:\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.esNoAprobadoPerfilMixto
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenNegativo
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenNegativo,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenNegativo.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Faltan " +
                                                            _vm._s(
                                                              _vm.caracteresFaltantesDictamenNegativo
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo >
                                                    _vm.caracteresMaximos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El comentario no debe exceder " +
                                                            _vm._s(
                                                              _vm.caracteresMaximos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.esPerfilInvestigacionCienciaBasica
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 23, 24, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(
                                        "\n              del Área\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ", recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud de conformidad con lo establecido en el marco de la Convocatoria 2026 para el reconocimiento en el Sistema\n              Nacional de Investigadoras e Investigadores, se determina que cumple con los Criterios Específicos de Evaluación\n              correspondientes al nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              de acuerdo al Área\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                          _vm._s(
                                            _vm.fraccionArticulo19Dictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19Dictamen
                                          ) +
                                          ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                      ),
                                    ]),
                                  ]
                                : _vm.esPerfilDesarrolloTecnologicoInnovacion
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 23, 24, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(" del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ", recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud de conformidad con lo establecido en el marco de la Convocatoria 2026 para el Reconocimiento en el Sistema\n              Nacional de Investigadoras e Investigadores, se determina que cumple con los Criterios Específicos de Evaluación\n              correspondientes al nivel "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(
                                        " de acuerdo al Área\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                          _vm._s(
                                            _vm.fraccionArticulo19Dictamen
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.descripcionArticulo19Dictamen
                                          ) +
                                          ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                      ),
                                    ]),
                                  ]
                                : _vm.esPerfilMixto
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 23, 24, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.comisionDictamen)),
                                      ]),
                                      _vm._v(" del Área "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen)),
                                      ]),
                                      _vm._v(
                                        ", recomienda al Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(".\n            "),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud de conformidad con lo establecido en el marco de la Convocatoria 2026 para el Reconocimiento en el Sistema\n              Nacional de Investigadoras e Investigadores, se determina que cumple con los Criterios Específicos de Evaluación\n              correspondientes al nivel "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nivelEvaluacionDictamen)
                                        ),
                                      ]),
                                      _vm._v(
                                        " de acuerdo al Área\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.areaClaveRomanaDictamen) +
                                            "."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.areaDictamen) + "."),
                                      ]),
                                      _vm._v(
                                        " Asimismo, la persona investigadora\n              cumple con los requisitos previstos en el artículo 19, fracción " +
                                          _vm._s(
                                            _vm.fraccionArticulo19Dictamen
                                          ) +
                                          ".\n              " +
                                          _vm._s(
                                            _vm.descripcionArticulo19Dictamen
                                          ) +
                                          ", del Reglamento del Sistema Nacional de Investigadoras e Investigadores.\n            "
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "line-break" }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "border-top mt-4 mb-4" }, [
                      _c("div", { staticClass: "mb-5 float-right" }),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "mb-5 float-right" },
                      [
                        this.revision.respuesta.evaluacionGuardadaFinal &&
                        _vm.revision.estado === _vm.aceptada
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  size: "md",
                                  disabled:
                                    _vm.hasAnyAuthority("ROLE_OPERADOR") &&
                                    _vm.authenticated,
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("entity.action.save")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("font-awesome-icon", {
                                  staticClass: "mr-2",
                                  attrs: { icon: "save" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }